import facebook1x from '@assets/img/facebook.png';
import facebook2x from '@assets/img/facebook@2x.png';
import instagram1x from '@assets/img/instagram.png';
import instagram2x from '@assets/img/instagram@2x.png';
import linkedin1x from '@assets/img/linkedin.png';
import linkedin2x from '@assets/img/linkedin@2x.png';

const SOCIAL_MEDIAS = [
  {
    link: 'https://pt-br.facebook.com/agencia.jussi/',
    img1x: facebook1x,
    img2x: facebook2x,
    imgAlt: 'Facebook logo',
  },
  {
    link: 'https://www.instagram.com/jussi/?hl=pt-br',
    img1x: instagram1x,
    img2x: instagram2x,
    imgAlt: 'Instagram logo',
  },
  {
    link: 'https://br.linkedin.com/company/agencia-jussi',
    img1x: linkedin1x,
    img2x: linkedin2x,
    imgAlt: 'Linkedin logo',
  },
];

export default SOCIAL_MEDIAS;
